import { CountUp } from 'countup.js';

class CountUpNumber {
  constructor(el) {
    this.el = el;
    this.targetEl = null;
    this.endValue = 0;
    this.countup = null;
    this.separator = '';
    this.decimalPlace = 0;

    if (!this.el) {
      return;
    }

    this.targetEl = this.el.querySelector('.js-numbers-target');
    if (this.el.dataset.number.toString().includes(',')) {
      this.el.dataset.number = this.el.dataset.number.replace(/,/g, '');
    }
    this.endValue = Number(this.el.dataset.number);
    this.separator = this.el.dataset.separator;
    // 小数点が含まれていれば小数点以下の桁数を1に
    this.decimalPlace = this.endValue.toString().includes('.') ? 1 : 0;

    this.countup = new CountUp(this.targetEl, this.endValue, {
      duration: 1,
      separator: this.separator,
      decimalPlaces: this.decimalPlace,
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.countup.start();
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0% 0% -23%',
    })

    observer.observe(this.el);
  }
}

export default class Numbers {
  constructor(selector) {
    this.selector = selector;
    this.els = document.querySelectorAll(selector);

    if (!this.els?.length) {
      return;
    }

    this.els.forEach((el) => {
      new CountUpNumber(el);
    })
  }
}
